module.exports = __webpack_public_path__ + "assets/img/noData.c6b91d1e.png";